export const EATER_COMMUNITY_ID = 450;
/**
 * Cyclone community UUID for Eater.
 *
 * This value comes from the Cyclone database and identifies the Eater community
 * within the Cyclone system. It is the same across all environments (staging/production).
 * The value is also defined in the `EATER_COMMUNITIES` config object's `cycloneCommunities` mapping.
 */
export const EATER_CYCLONE_COMMUNITY_ID =
  "59d671b0-25d0-4d7a-8792-caef1f0de9ab";

export interface EaterCommunityConfig {
  name: string;
  displayName: string;
  subdomain: string | null;
  domain: string;
  wpSiteId: number;
  isPrimaryCommunity?: boolean;
  sailthruSlug?: string;
  cycloneCommunities?: Record<
    string,
    {
      displayName: string;
      isPrimaryCommunity: boolean;
      cycloneCommunityId: string;
      cycloneCommunityCacheId: number;
    }
  >;
}
export const EATER_COMMUNITIES: Record<string, EaterCommunityConfig> = {
  [EATER_COMMUNITY_ID]: {
    name: "Eater",
    displayName: "Eater",
    subdomain: null,
    domain: "eater.com",
    wpSiteId: 2,
    isPrimaryCommunity: true,
    sailthruSlug: "eater",
    cycloneCommunities: {
      [EATER_CYCLONE_COMMUNITY_ID]: {
        displayName: "Eater",
        isPrimaryCommunity: true,
        cycloneCommunityId: EATER_CYCLONE_COMMUNITY_ID,
        cycloneCommunityCacheId: 3,
      },
    },
  },
  454: {
    name: "Eater Maine",
    displayName: "Maine",
    subdomain: "maine",
    domain: "maine.eater.com",
    wpSiteId: 3,
  },
  456: {
    name: "Eater Boston",
    displayName: "Boston",
    subdomain: "boston",
    domain: "boston.eater.com",
    wpSiteId: 4,
    sailthruSlug: "boston-eater",
  },
  458: {
    name: "Eater Montreal",
    displayName: "Montreal",
    subdomain: "montreal",
    domain: "montreal.eater.com",
    wpSiteId: 5,
    sailthruSlug: "montreal-eater",
  },
  460: {
    name: "Eater NY",
    displayName: "New York",
    subdomain: "ny",
    domain: "ny.eater.com",
    wpSiteId: 6,
    sailthruSlug: "ny-eater",
  },
  464: {
    name: "Eater Philly",
    displayName: "Philadelphia",
    subdomain: "philly",
    domain: "philly.eater.com",
    wpSiteId: 8,
    sailthruSlug: "philly-eater",
  },
  466: {
    name: "Eater DC",
    displayName: "Washington DC",
    subdomain: "dc",
    domain: "dc.eater.com",
    wpSiteId: 9,
    sailthruSlug: "dc-eater",
  },
  468: {
    name: "Eater Toronto",
    displayName: "Toronto",
    subdomain: "toronto",
    domain: "toronto.eater.com",
    wpSiteId: 10,
  },
  470: {
    name: "Eater Carolinas",
    displayName: "Carolinas",
    subdomain: "carolinas",
    domain: "carolinas.eater.com",
    wpSiteId: 11,
    sailthruSlug: "carolinas-eater",
  },
  472: {
    name: "Eater Miami",
    displayName: "Miami",
    subdomain: "miami",
    domain: "miami.eater.com",
    wpSiteId: 12,
    sailthruSlug: "miami-eater",
  },
  474: {
    name: "Eater Detroit",
    displayName: "Detroit",
    subdomain: "detroit",
    domain: "detroit.eater.com",
    wpSiteId: 13,
    sailthruSlug: "detroit-eater",
  },
  476: {
    name: "Eater Atlanta",
    displayName: "Atlanta",
    subdomain: "atlanta",
    domain: "atlanta.eater.com",
    wpSiteId: 14,
    sailthruSlug: "atlanta-eater",
  },
  478: {
    name: "Eater Louisville",
    displayName: "Louisville",
    subdomain: "louisville",
    domain: "louisville.eater.com",
    wpSiteId: 15,
  },
  480: {
    name: "Eater Nashville",
    displayName: "Nashville",
    subdomain: "nashville",
    domain: "nashville.eater.com",
    wpSiteId: 16,
    sailthruSlug: "nashville-eater",
  },
  482: {
    name: "Eater Chicago",
    displayName: "Chicago",
    subdomain: "chicago",
    domain: "chicago.eater.com",
    wpSiteId: 17,
    sailthruSlug: "chicago-eater",
  },
  484: {
    name: "Eater New Orleans",
    displayName: "New Orleans",
    subdomain: "nola",
    domain: "nola.eater.com",
    wpSiteId: 18,
    sailthruSlug: "nola-eater",
  },
  486: {
    name: "Eater Twin Cities",
    displayName: "Twin Cities",
    subdomain: "twincities",
    domain: "twincities.eater.com",
    wpSiteId: 19,
    sailthruSlug: "twincities-eater",
  },
  488: {
    name: "Eater Houston",
    displayName: "Houston",
    subdomain: "houston",
    domain: "houston.eater.com",
    wpSiteId: 20,
    sailthruSlug: "houston-eater",
  },
  490: {
    name: "Eater Dallas",
    displayName: "Dallas",
    subdomain: "dallas",
    domain: "dallas.eater.com",
    wpSiteId: 21,
    sailthruSlug: "dallas-eater",
  },
  492: {
    name: "Eater Austin",
    displayName: "Austin",
    subdomain: "austin",
    domain: "austin.eater.com",
    wpSiteId: 22,
    sailthruSlug: "austin-eater",
  },
  494: {
    name: "Eater Denver",
    displayName: "Denver",
    subdomain: "denver",
    domain: "denver.eater.com",
    wpSiteId: 23,
    sailthruSlug: "denver-eater",
  },
  496: {
    name: "Eater Vegas",
    displayName: "Las Vegas",
    subdomain: "vegas",
    domain: "vegas.eater.com",
    wpSiteId: 24,
    sailthruSlug: "vegas-eater",
  },
  498: {
    name: "Eater San Diego",
    displayName: "San Diego",
    subdomain: "sandiego",
    domain: "sandiego.eater.com",
    wpSiteId: 25,
    sailthruSlug: "sandiego-eater",
  },
  500: {
    name: "Eater LA",
    displayName: "Los Angeles",
    subdomain: "la",
    domain: "la.eater.com",
    wpSiteId: 26,
    sailthruSlug: "la-eater",
  },
  502: {
    name: "Eater Seattle",
    displayName: "Seattle",
    subdomain: "seattle",
    domain: "seattle.eater.com",
    wpSiteId: 27,
    sailthruSlug: "seattle-eater",
  },
  504: {
    name: "Eater SF",
    displayName: "San Francisco",
    subdomain: "sf",
    domain: "sf.eater.com",
    wpSiteId: 28,
    sailthruSlug: "sf-eater",
  },
  506: {
    name: "Eater Portland",
    displayName: "Portland",
    subdomain: "pdx",
    domain: "pdx.eater.com",
    wpSiteId: 29,
    sailthruSlug: "pdx-eater",
  },
  508: {
    name: "Eater Vancouver",
    displayName: "Vancouver",
    subdomain: "vancouver",
    domain: "vancouver.eater.com",
    wpSiteId: 30,
  },
  707: {
    name: "Eater London",
    displayName: "London",
    subdomain: "london",
    domain: "london.eater.com",
    wpSiteId: 31,
    sailthruSlug: "eater-london",
  },
  782: {
    name: "Eater Phoenix",
    displayName: "Phoenix",
    subdomain: "phoenix",
    domain: "phoenix.eater.com",
    wpSiteId: 32,
    sailthruSlug: "phoenix-eater",
  },
};
